import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import * as moment from 'moment';
class TeamCelendarEditEntryDialog {
    constructor(parent: any, inputData: any) {
        this.Parent = parent;
        if (inputData) {
            this.FromDateJs(inputData.FromDate);
            this.ToDateJs(inputData.ToDate);
            this.Name(inputData.Name);
            this.Description(inputData.Description);
            this.IsWholeDay(inputData.IsWholeDay);
            this.Location(inputData.Location);
        }
        else {
            this.GetNearestHour();
        }
    }
    Bao = Bao;
    Parent: any;
    Name: KnockoutObservable<string> = ko.observable("");
    Description: KnockoutObservable<string> = ko.observable("");
    Location: KnockoutObservable<string> = ko.observable("");
    FromDateJs: KnockoutObservable<string> = ko.observable("");
    ToDateJs: KnockoutObservable<string> = ko.observable("");
    IsWholeDay: KnockoutObservable<boolean> = ko.observable(false);
    ItemCompleteCheck() {
        if (Bao.Utils.String.IsNullOrWhitespace(this.Name()) || Bao.Utils.String.IsNullOrWhitespace(this.FromDateJs()) || (Bao.Utils.String.IsNullOrWhitespace(this.ToDateJs()) && this.IsWholeDay() === false) || (this.FromDateJs() > this.ToDateJs())) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return false;
        }
        return true;
    }
    GetNearestHour() {
        return Bao.post("TeamCalendarView/GetNearestHour").done((result) => {
            if (result) {
                this.FromDateJs(result.FromDate);
                this.ToDateJs(result.ToDate);
            }
        });
    }
    adjustAllDayDates = () => {
        if (this.IsWholeDay()) {
            let newEndDate = moment(this.ToDateJs(), Bao.Utils.DateFormat).add(1, 'days').subtract(1, 'minutes').format(Bao.Utils.DateFormat);
            this.ToDateJs(newEndDate);
        } 
    }
}
export default TeamCelendarEditEntryDialog;